export default __webpack_public_path__ + "static/media/anirban.cd7b4bb3.png";